export default "__VITE_ASSET__CErV3Szo__"